import { v4 as uuidv4 } from 'uuid';
import { preloadImages, commonImagesList } from '../../../../commons/utils/imagePreloader';

function finalizeSessionInit({ params, authSession }) {
    if (this.isOauth(params)) {
        this.persistOauthInfo({ session: authSession, params });
    }

    const newSession = this.persistToken({ params });
    if (newSession) {
        this.session = newSession;
    } else {
        this.session = authSession;
    }

    this.redirectToHome(params);
    preloadImages(commonImagesList());
    this.observed.initialized = uuidv4();
}

export function redirectToHome(params) {
    // If coming back from an OAuth flow (Google, Outlook, etc.), go straight to manage.
    if (this.isOauth(params) || params.token) {
        this.navigate('/manage');
        return;
    }
    const path = this.page?.path || '/';
    if (path === '/login') {
        this.navigate('/');
    }
}

export default finalizeSessionInit;
